// extracted by mini-css-extract-plugin
export default {"root":"FilterTripType__root--CPR8S","item":"FilterTripType__item--VrEe3"};